define([], function() {
        "use strict";
        return {
            "(1 - strokewidth % 2) / 2": function(strokewidth) { return (1 - strokewidth % 2) / 2; }
        };
    });